// extracted by mini-css-extract-plugin
export default {"optionsWrapper":"styles_optionsWrapper__ZcgkN","optionsDots":"styles_optionsDots__P0KUZ","options":"styles_options__AQBOp","item":"styles_item__SzvpG","icon":"styles_icon__5aXxz"};